export default {
    name: 'calculatorsFluid',
    serverName: '/api/v1/fluid_calculator/fluid_calculator/',
    apiUrl: '/api/v1/fluid_calculator/fluid_calculator/',
    apiRateNozzleUrl: '/api/v1/fluid_calculator/fluid_consumption_rate_through_nozzle/',
    apiNozzleColorUrl: '/api/v1/fluid_calculator/nozzle_color/',
    apiNozzlePressureUrl: '/api/v1/fluid_calculator/nozzle_pressure/'
};
